'use client';

import React from 'react';
import {
    GraduationCap,
    Users,
    ClipboardCheck,
    PieChart,
    Calendar,
    AlertCircle,
    CheckCircle2,
    XCircle,
    TrendingUp,
    ChevronRight,
    ArrowUpRight
} from 'lucide-react';

export default function GuruDashboard() {
    return (
        <div className="p-6 lg:p-10 space-y-10 animate-in fade-in duration-700 bg-background/50">
            {/* Header Dashboard Guru / Staff */}
            <div className="bg-white border border-border-main px-8 py-10 rounded-4xl flex flex-col md:flex-row justify-between items-start md:items-end gap-4 shadow-sm relative overflow-hidden">
                <div className="absolute top-0 right-0 w-64 h-64 bg-primary/5 rounded-full blur-3xl -mr-20 -mt-20"></div>
                <div className="relative z-10 space-y-1">
                    <h1 className="text-3xl lg:text-4xl font-bold tracking-tight text-foreground">
                        Dashboard <span className="text-primary">Guru / Staff</span>
                    </h1>
                    <p className="text-secondary font-bold uppercase tracking-[0.2em] text-[10px]">
                        Monitoring Data Siswa & Status Pembayaran SPP
                    </p>
                </div>
                <div className="relative z-10 flex gap-3 w-full md:w-auto">
                    <button className="flex-1 md:flex-none px-6 py-3.5 gradient-green text-white rounded-2xl text-[11px] font-bold uppercase tracking-widest hover:shadow-xl hover:shadow-primary/20 transition-all flex items-center justify-center gap-2">
                        <Calendar className="w-4 h-4" /> Kalender Akademik
                    </button>
                </div>
            </div>

            {/* Summary Section: Data Siswa & Tunggakan */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="bg-surface border border-border-main p-8 rounded-[2.5rem] shadow-sm group hover:border-primary/30 transition-all flex items-center gap-6">
                    <div className="w-16 h-16 rounded-2xl bg-primary-soft text-primary flex items-center justify-center shrink-0 transition-transform group-hover:scale-110">
                        <Users className="w-8 h-8" />
                    </div>
                    <div>
                        <p className="text-[10px] font-black text-muted uppercase tracking-widest mb-1">Total Siswa Binaan</p>
                        <h3 className="text-3xl font-black text-foreground">32 <span className="text-sm font-bold text-muted">Anak</span></h3>
                    </div>
                </div>

                <div className="bg-surface border border-border-main p-8 rounded-[2.5rem] shadow-sm group hover:border-error/30 transition-all flex items-center gap-6">
                    <div className="w-16 h-16 rounded-2xl bg-error-soft text-error flex items-center justify-center shrink-0 transition-transform group-hover:scale-110">
                        <AlertCircle className="w-8 h-8" />
                    </div>
                    <div>
                        <p className="text-[10px] font-black text-muted uppercase tracking-widest mb-1">Belum Bayar SPP</p>
                        <h3 className="text-3xl font-black text-error">8 <span className="text-sm font-bold text-muted">Anak</span></h3>
                    </div>
                </div>

                <div className="bg-surface border border-border-main p-8 rounded-[2.5rem] shadow-sm group hover:border-success/30 transition-all flex items-center gap-6">
                    <div className="w-16 h-16 rounded-2xl bg-success-soft text-success flex items-center justify-center shrink-0 transition-transform group-hover:scale-110">
                        <CheckCircle2 className="w-8 h-8" />
                    </div>
                    <div>
                        <p className="text-[10px] font-black text-muted uppercase tracking-widest mb-1">Sudah Bayar SPP</p>
                        <h3 className="text-3xl font-black text-success">24 <span className="text-sm font-bold text-muted">Anak</span></h3>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
                {/* PIE Chart: Pembayaran SPP (Belum & Sudah) */}
                <div className="lg:col-span-8 bg-surface border border-border-main rounded-[2.5rem] p-10 shadow-sm relative overflow-hidden">
                    <div className="flex flex-col md:flex-row items-center gap-12">
                        <div className="flex-1 space-y-8">
                            <div>
                                <h3 className="text-xl font-black text-foreground flex items-center gap-2 uppercase tracking-tight">
                                    <PieChart className="w-6 h-6 text-primary" /> Statistik Pembayaran
                                </h3>
                                <p className="text-[10px] text-muted font-bold uppercase tracking-widest mt-1">Status Kolektibilitas SPP Kelas — Februari 2026</p>
                            </div>

                            <div className="space-y-4">
                                <div className="flex items-center justify-between p-5 bg-success-soft/30 border border-success/10 rounded-3xl">
                                    <div className="flex items-center gap-4">
                                        <div className="w-10 h-10 rounded-xl bg-success text-white flex items-center justify-center">
                                            <CheckCircle2 className="w-5 h-5" />
                                        </div>
                                        <div>
                                            <p className="text-xs font-black text-foreground uppercase">Sudah Melunasi</p>
                                            <p className="text-[10px] text-muted font-bold">24 Siswa</p>
                                        </div>
                                    </div>
                                    <span className="text-lg font-black text-success">75%</span>
                                </div>

                                <div className="flex items-center justify-between p-5 bg-error-soft/30 border border-error/10 rounded-3xl">
                                    <div className="flex items-center gap-4">
                                        <div className="w-10 h-10 rounded-xl bg-error text-white flex items-center justify-center">
                                            <XCircle className="w-5 h-5" />
                                        </div>
                                        <div>
                                            <p className="text-xs font-black text-foreground uppercase">Masih Menunggak</p>
                                            <p className="text-[10px] text-muted font-bold">8 Siswa</p>
                                        </div>
                                    </div>
                                    <span className="text-lg font-black text-error">25%</span>
                                </div>
                            </div>

                            <button className="w-full py-4 bg-white border border-dashed border-border-main rounded-2xl text-[10px] font-black text-muted uppercase hover:border-primary hover:text-primary transition-all flex items-center justify-center gap-2">
                                <TrendingUp className="w-4 h-4" /> Proses Reminder Blast Orang Tua
                            </button>
                        </div>

                        {/* Custom Visual Pie Chart */}
                        <div className="relative w-56 h-56 md:w-72 md:h-72 shrink-0 flex items-center justify-center">
                            <svg viewBox="0 0 36 36" className="w-full h-full transform -rotate-90">
                                <circle cx="18" cy="18" r="16" fill="none" stroke="#fee2e2" strokeWidth="3" />
                                <circle cx="18" cy="18" r="16" fill="none" stroke="var(--color-primary)" strokeWidth="3" strokeDasharray="75, 100" />
                            </svg>
                            <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
                                <span className="text-4xl font-black text-foreground">75%</span>
                                <span className="text-[10px] font-black text-muted uppercase tracking-widest mt-1">Lunas</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right: Info Ringkasan Lainnya */}
                <div className="lg:col-span-4 space-y-8">
                    <div className="bg-surface border border-border-main rounded-[2.5rem] p-8 shadow-sm h-full flex flex-col justify-between">
                        <div className="space-y-8">
                            <h3 className="text-sm font-black text-foreground uppercase tracking-widest flex items-center gap-2">
                                <TrendingUp className="w-4 h-4 text-primary" /> Efisiensi Administrasi
                            </h3>

                            <div className="space-y-6">
                                <div className="p-6 bg-primary-soft/50 border border-primary/10 rounded-3xl">
                                    <p className="text-[10px] font-black text-primary uppercase tracking-widest mb-2">Tingkat Kehadiran Kelas</p>
                                    <h4 className="text-3xl font-black text-foreground">98.5%</h4>
                                    <div className="mt-4 h-2 w-full bg-white rounded-full overflow-hidden">
                                        <div className="h-full bg-primary w-[98.5%] transition-all duration-1000"></div>
                                    </div>
                                </div>

                                <div className="space-y-3">
                                    <p className="text-[10px] font-black text-muted uppercase tracking-widest ml-1">Reminder Hari Ini</p>
                                    {[
                                        'Update nilai kuis Matematika',
                                        'Tagihan SPP 8 siswa terlampaui',
                                        'Rapat guru jam 14.00 WIB'
                                    ].map((note, i) => (
                                        <div key={i} className="flex items-center gap-3 p-3.5 bg-background border border-border-main rounded-2xl group hover:border-primary/20 transition-all cursor-pointer">
                                            <div className="w-1.5 h-1.5 rounded-full bg-primary shrink-0"></div>
                                            <p className="text-[11px] font-bold text-foreground group-hover:text-primary transition-colors">{note}</p>
                                            <ChevronRight className="w-3.5 h-3.5 ml-auto text-muted group-hover:text-primary" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <button className="w-full mt-8 py-4 bg-primary text-white rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-xl shadow-primary/20 hover:scale-[1.02] transition-all">
                            Buka Manajemen Siswa
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
